import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
export default function WarrantyOptionCard(_ref) {
  var warrantyInfo = _ref.warrantyInfo;
  if (!warrantyInfo) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-2358146765" + " " + 'option',
      children: [/*#__PURE__*/_jsxs("div", {
        className: "jsx-2358146765" + " " + 'period',
        children: [/*#__PURE__*/_jsx("div", {
          className: "jsx-2358146765" + " " + 'time',
          children: warrantyInfo.period
        }), /*#__PURE__*/_jsx("div", {
          className: "jsx-2358146765" + " " + 'word',
          children: "Warranty"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "jsx-2358146765" + " " + 'details',
        children: [/*#__PURE__*/_jsx("div", {
          className: "jsx-2358146765" + " " + 'title',
          children: warrantyInfo.titleLong
        }), /*#__PURE__*/_jsx("div", {
          className: "jsx-2358146765" + " " + 'info',
          children: warrantyInfo.description
        })]
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2358146765",
      children: [".option.jsx-2358146765{display:grid;grid-template-columns:-webkit-min-content 1fr;grid-template-columns:min-content 1fr;margin-bottom:10px;}", ".option.jsx-2358146765:last-child{margin-bottom:0;}", ".period.jsx-2358146765{padding:15px;background:#21409A;color:white;font-size:1.125rem;font-weight:700;text-align:center;line-height:1.2;}", ".details.jsx-2358146765{-webkit-box-flex:1;-ms-flex-positive:1;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;padding:15px;border:1px solid #CCD0E0;border-left:0;}", ".title.jsx-2358146765{padding-bottom:5px;margin-bottom:5px;border-bottom:1px solid #9BA3C3;}", ".info.jsx-2358146765{font-size:0.75rem;font-style:italic;}"]
    })]
  });
}